module.exports = __webpack_public_path__ + "img/LogoManutenzioneTrasparente2.245882c1.png";